import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Table } from '../../../common/table'
import { formatVal, isInValidValue } from '../../../helpers/value'
import { getDataItemByRowId, getOrderType } from '../common/helper'
import { PopupPaymentInformation } from '../common/popupPaymentInformation'
import { DateOrderedCell } from '../common/table/DateOrderedCell'
import { TableFooter } from './TableFooter'
import {
  ORDER_MANAGE_KEYS,
  ORDER_MANAGE_TITLE,
  PAYMENT_METHOD,
  REPORT_TYPES,
} from './constants'
import {
  selectIds,
  selectIsLoadingListOrders,
  selectOrdersData,
  selectOrdersDataById,
} from './store/slice'
import { DetailCell } from './table/DetailCell'
import { OrderDescriptionCell } from './table/OrderDescriptionCell'
import { OrderStatusCell } from './table/OrderStatusCell'
import { PaymentStatusCell } from './table/PaymentStatusCell'
import { VolumeCell } from './table/VolumeCell'

export const TableContent = () => {
  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoadingListOrders)
  const data = useSelector(selectOrdersData)
  const locale = useSelector((state) => state.i18n.locale)

  const [isOpenPayNow, setIsOpenPayNow] = useState(false)
  const [orderId, setOrderId] = useState(null)
  const [isScreening, setIsScreening] = useState(false)

  const getDataByOrderId = data?.find((item) => item.id === orderId) || {}
  const discountedAmount = getDataByOrderId?.details?.reduce(
    (acc, item) => acc + item.discountedPrice,
    0,
  )

  const handlePayNow = (rowId, isScreening) => {
    setIsOpenPayNow(true)
    setOrderId(rowId)
    setIsScreening(isScreening)
  }

  return (
    <>
      <Table
        ids={ids}
        isLoading={isLoading}
        isNoDataWithHead
        autoHeightMax={500}
        getDataFromRedux={selectOrdersDataById}
        schema={getSchema(data, handlePayNow, locale)}
        renderPagination={() => <TableFooter />}
      />
      {isOpenPayNow && (
        <PopupPaymentInformation
          isShow={isOpenPayNow}
          setIsShow={setIsOpenPayNow}
          orderId={orderId}
          orderType={getOrderType(getDataByOrderId)}
          isScreening={isScreening}
          oldPrice={getDataByOrderId?.amount}
          exchangeRateAPI={getDataByOrderId?.exchangeRate}
          discountedAmount={discountedAmount}
          discountValue={getDataByOrderId?.discountValue}
          vatPrice={getDataByOrderId?.vat}
          grandTotalPrice={getDataByOrderId?.totalAmount}
        />
      )}
    </>
  )
}

const getSchema = (data, handlePayNow, locale) => {
  return ORDER_MANAGE_TITLE.map((item) => {
    const result = {
      title: <Translate value={item.title} />,
      colId: item.key,
    }

    switch (item.key) {
      case ORDER_MANAGE_KEYS.ORDER:
        return {
          ...result,
          render: (val) => {
            return val
          },
        }
      case ORDER_MANAGE_KEYS.ORDER_DESCRIPTION:
        return {
          ...result,
          render: (val, { rowId }) => {
            return (
              <OrderDescriptionCell
                data={data}
                rowId={rowId}
                orderInfoKey={'details'}
                orderNameKey={'fiinGateReportTypeName'}
              />
            )
          },
        }
      case ORDER_MANAGE_KEYS.QUANTITY:
        return {
          ...result,
          render: (val, { rowId }) => {
            return (
              <VolumeCell
                data={data}
                rowId={rowId}
                orderInfoKey={'details'}
                orderNameKey={'fiinGateReportTypeName'}
                orderIdKey={'fiinGateReportTypeId'}
                orderVolumeKey={'numOfCompanies'}
              />
            )
          },
        }
      case ORDER_MANAGE_KEYS.DATE_ORDERED:
        return {
          ...result,
          render: (val) => {
            return <DateOrderedCell val={val} locale={locale} />
          },
        }
      case ORDER_MANAGE_KEYS.ORDER_STATUS:
        return {
          ...result,
          render: (val, { rowId }) => {
            const itemRow = getDataItemByRowId(data, rowId)
            return <OrderStatusCell val={itemRow.status} />
          },
        }
      case ORDER_MANAGE_KEYS.PAYMENT_METHOD:
        return {
          ...result,
          render: (val, { rowId }) => {
            const itemRow = getDataItemByRowId(data, rowId)
            if (itemRow?.totalAmount === 0) return ''
            return (
              !isInValidValue(val) && <Translate value={PAYMENT_METHOD[val]} />
            )
          },
        }
      case ORDER_MANAGE_KEYS.TOTAL:
        return {
          ...result,
          render: (val, { rowId }) => {
            const itemRow = getDataItemByRowId(data, rowId)
            if (itemRow?.paymentMethod === 'Package') return ''
            return (
              !isInValidValue(val) && <>{formatVal(val, locale, false, 0)}</>
            )
          },
        }
      case ORDER_MANAGE_KEYS.PAYMENT_STATUS:
        return {
          ...result,
          render: (val, { rowId }) => {
            const orderStatus = getDataItemByRowId(data, rowId)?.status
            return (
              <PaymentStatusCell
                val={val}
                orderStatus={orderStatus}
                handlePayNow={() => handlePayNow(rowId)}
              />
            )
          },
        }
      case ORDER_MANAGE_KEYS.DETAIL:
        return {
          ...result,
          render: (val, { rowId }) => {
            const isScreeningReport =
              data[rowId]?.reportTypeId === REPORT_TYPES.SCREENING
            return (
              <DetailCell val={val} isScreeningReport={isScreeningReport} />
            )
          },
        }
      default:
        break
    }

    return {
      ...result,
      render: (val) => {
        return val
      },
    }
  })
}
